import * as Sentry from '@sentry/browser'
import React, { useEffect, useState } from 'react'
import { Switch } from 'react-router-dom'

import { Home, QuestionCreate, QuestionForm, QuestionSearch } from 'views'
import { Layout, PrivateRoute } from 'components'
import { Client, getToken, envPicker } from 'utils'

import './App.module.scss'

const App = () => {
  const timeoutRef = null
  const [loadingTracker, setLoadingTracker] = useState(true)
  const [user, setUser] = useState(undefined)

  useEffect(() => {
    const envTranslator = envName => {
      if (envName.includes('local') || envName.includes('staging')) return 'staging'
      return 'production'
    }
    const initializePlurallTracker = async (timeout = 3000) =>
      new Promise((resolve, reject) => {
        const environment = envTranslator(envPicker())
        const startTime = Date.now()
        const checkTracker = () => {
          if (window.PlurallTracker) {
            try {
              window.PLURALL_TRACKER = new window.PlurallTracker({
                clientId: 'questions-form',
                environment,
              })
              resolve()
            } catch (error) {
              if (Date.now() - startTime < timeout) {
                timeoutRef.current = setTimeout(checkTracker, 100)
              }
              reject()
            }
          } else if (Date.now() - startTime > timeout) {
            console.error('Timeout waiting for PlurallTracker to initialize')
            reject()
          } else {
            timeoutRef.current = setTimeout(checkTracker, 100)
          }
        }
        checkTracker()
      })

    const getProfile = async () => {
      const client = new Client()
      const userProfile = await client.getProfile()
      if (userProfile) {
        setUser(userProfile)
      }
    }

    initializePlurallTracker()
      .then(() => {
        setLoadingTracker(false)
        if (window.PLURALL_TRACKER) {
          window.PLURALL_TRACKER.pageView()
        }
      })
      .catch(error => {
        setLoadingTracker(false)
        console.error('Failed to initialize PlurallTracker:', error)
      })

    getProfile()
  }, [])

  useEffect(() => {
    if (user) {
      Sentry.configureScope(scope => {
        scope.setUser({ email: user.email, id: user.somosId.toString(), username: user.name })
        scope.setExtras({ accessToken: getToken() })
      })
    }
  }, [user])

  if (loadingTracker || !user) {
    return <>Aguarde, carregando</>
  }
  return (
    <Layout>
      <Switch>
        <PrivateRoute path='/create/question' component={QuestionCreate} />
        <PrivateRoute path='/create' component={QuestionForm} />
        <PrivateRoute path='/search' component={QuestionSearch} />
        <PrivateRoute path='/' component={Home} />
      </Switch>
    </Layout>
  )
}

export default App
